module.exports = __webpack_public_path__ + "assets/img/组 434@2x.227014b9.png";